export function formatTRY(n) {
  if (n == null) return "";
  return new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 2 }).format(n) + " ₺";
}

export function priceLabel(listing) {
  const u = listing.unit ? `/ ${listing.unit}` : "";
  switch (listing.price_type) {
    case "fixed":
      return listing.price != null ? `${formatTRY(listing.price)} ${u}` : "Fiyat belirtilmemiş";
    case "range":
      return `${formatTRY(listing.price_min)} – ${formatTRY(listing.price_max)} ${u}`;
    case "tiered": {
      const min = listing.tiers && listing.tiers.length ? Math.min(...listing.tiers.map((t) => t.price)) : null;
      return min != null ? `${formatTRY(min)}'den başlayan ${u}` : "Kademeli fiyat";
    }
    case "negotiable":
      return listing.price != null ? `${formatTRY(listing.price)} ${u} • Pazarlık` : "Pazarlık Yapılabilir";
    case "offer":
      return "Teklif Usulü";
    default:
      return "";
  }
}

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 3600) return `${Math.max(1, Math.floor(diff / 60))} dk önce`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} saat önce`;
  if (diff < 2592000) return `${Math.floor(diff / 86400)} gün önce`;
  return d.toLocaleDateString("tr-TR");
}

export function formatDate(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleDateString("tr-TR", { day: "numeric", month: "long", year: "numeric" });
}
